import { combineReducers } from 'redux'
import EmployeeCategory from './fetchEmployeeCaregory'
import offers from './fetchOffers'
import signUpReducer from './signUpReducer';
import Authentication from './authentication';
import MobileNavReducer from './mobileNav';
import CleanerReducer from './getCleaner'
import CarpenterReducer from './getCarpenter'
import ElectricianReducer from './getElectrician'
import ReviewReducer from './getReviews'
import employeeReducer from './employeeReducer'
import categoryReviewReducer from './categoryReviewReducer';
import AllServicesReducer from './allServicesReducers';
import BasicCartReducer from './basicCartReducer';
import DetailCartReducer from './getDetailCart';
import OrderReducer from './orderReducer';
import SearchReducer from './SearchReducer';
import getHiringEmployeeCategory from './getHiringEmployeeCategory'
import recommanderReducer from './recommanderReducer'
import recommanderReducerDetail from './recommanderReducerDetail'
import ThemeReducer from './ThemeReducer';
import csrfReducer from './csrfReducer';
import shouldFetchUser from './shouldFetchUser'
export default combineReducers({
    EmployeeCategory: EmployeeCategory,
    couponOffers: offers,
    signUp: signUpReducer,
    Authentication: Authentication,
    mobileNav: MobileNavReducer,
    cL: CleanerReducer,
    cP: CarpenterReducer,
    eL: ElectricianReducer,
    mainReview: ReviewReducer,
    employees: employeeReducer,
    categoryReview: categoryReviewReducer,
    allServices: AllServicesReducer,
    basicCart: BasicCartReducer,
    detailCart: DetailCartReducer,
    orders: OrderReducer,
    searchResult: SearchReducer,
    hiring: getHiringEmployeeCategory,
    basicServiceRecommandation: recommanderReducer,
    detailServiceRecommandation: recommanderReducerDetail,
    theme: ThemeReducer,
    csrf: csrfReducer,
    shouldFetchUser,
})